import styled from 'styled-components';



const ButtonControl = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 40px;
  height: 40px;
  margin-left: 1.5px;
  margin-right: 1.5px;
  cursor: pointer;
`;



export default ButtonControl;
